import { NgModule } from '@angular/core';

import { LzFeedbackModule } from './modules/lz-feedback/lz-feedback.module';
import { LzUserMessagesModule } from './modules/lz-user-messages/lz-user-messages.module';
import { LzMessageModule } from './modules/lz-message/lz-message.module';
import { LzPurchaseModule } from './modules/lz-purchase/lz-purchase.module';
import { LzUserModule } from './modules/lz-user/lz-user.module';
import { LzBookmarkModule } from './modules/lz-bookmark/lz-bookmark.module';
import { LzLogModule } from './modules/lz-log/lz-log.module';
import { LzHeaderModule } from './modules/lz-header/lz-header.module';
import { LzPopupModule } from './modules/lz-popup/lz-popup.module';
import { SharingModule } from './modules/lz-sharing/sharing.module';

import { CustomRequestService } from './services/custom-request/custom-request.service';
import { LzCookieService } from './services/lz-cookie/lz-cookie';
import { DomService } from './services/dom-service/dom-service.service';
import { LzSettingsService } from './services/settings/settings';
import { LzSocketService } from './services/socket/socket';
import { LzSeoService } from './services/seo/seo';
import { LzProductConfig } from './services/product-config/poduct-config';
import { LzLanguageService } from './services/lz-language/lz-language.service';
import { ErrorLogService } from './services/error-log/error-log.service';

@NgModule({
  imports: [
    LzFeedbackModule,
    LzUserMessagesModule,
    LzMessageModule,
    LzPurchaseModule,
    LzUserModule,
    LzBookmarkModule,
    LzLogModule,
    LzHeaderModule,
    LzPopupModule,
    SharingModule
  ],
  providers: [
    CustomRequestService,
    LzCookieService,
    DomService,
    LzSettingsService,
    LzSocketService,
    LzSeoService,
    LzProductConfig,
    LzLanguageService,
    ErrorLogService
  ],
  exports: [
    LzFeedbackModule,
    LzUserMessagesModule,
    LzMessageModule,
    LzPurchaseModule,
    LzUserModule,
    LzBookmarkModule,
    LzLogModule,
    LzHeaderModule,
    LzPopupModule,
    SharingModule
  ]
})

export class PLTHeaderModule { }
